import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { apiError } from "@/lib/apiError";
import { Loader2, Terminal } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { inputClass, btnPrimary, btnGhost } from "@/components/Brand";

/** Unlisted developer / super-admin entrance. Not linked from any navigation. */
export default function DevLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const data = await login(form.email, form.password);
      if (data.platform_role !== "platform_owner") {
        toast.error("This entrance is for platform operators only");
        navigate("/dashboard", { replace: true });
        return;
      }
      navigate("/platform", { replace: true });
    } catch (err) {
      toast.error(apiError(err, "Access denied"));
    } finally {
      setBusy(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#050505] text-[#F3F3F1] flex items-center justify-center px-5" data-testid="dev-login-page">
      <div className="w-full max-w-sm fade-up">
        <div className="flex items-center gap-3 mb-8">
          <Terminal size={18} className="text-[#D4AF37]" />
          <span className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]">
            seleksa · console
          </span>
        </div>
        <h1 className="text-3xl tracking-tighter font-medium mb-2">Operator access</h1>
        <p className="text-xs text-[#707070] mb-10 font-mono-accent">Restricted — platform pricing & tenants</p>

        <form onSubmit={submit} className="space-y-6">
          <input data-testid="dev-email-input" type="email" className={inputClass} placeholder="email"
            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required autoComplete="off" />
          <input data-testid="dev-password-input" type="password" className={inputClass} placeholder="password"
            value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required autoComplete="off" />
          <button data-testid="dev-login-submit-btn" disabled={busy} className={`${btnPrimary} w-full py-4`}>
            {busy && <Loader2 size={14} className="animate-spin" />} Authenticate
          </button>
        </form>

        <div className="flex items-center gap-4 my-8">
          <span className="h-px flex-1 bg-[#2A2A2A]" />
          <span className="text-[10px] tracking-[0.2em] uppercase text-[#707070]">or</span>
          <span className="h-px flex-1 bg-[#2A2A2A]" />
        </div>
        <button data-testid="dev-google-btn" onClick={googleLogin} className={`${btnGhost} w-full py-3.5`}>
          Continue with Google
        </button>
      </div>
    </div>
  );
}
